var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v(" "+_vm._s(_vm.accountNumber)+" "),(_vm.isAdmin())?_c('span',[(_vm.eyeStatus)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":""},on:{"click":_vm.eyeClick}},[_vm._v("mdi-eye")]):_c('v-icon',{staticClass:"ml-2",attrs:{"small":""},on:{"click":_vm.eyeClick}},[_vm._v("mdi-eye-off")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }